import axios from "axios";

export default axios.create({
    baseURL: "https://api.unsplash.com",
    headers: {
      Authorization: 'Client-ID 134ca1ee567eae7987cc944e4c28c0b98eb72702e9e3cb4923fb21a423129c98'
    }
});